import { filter } from 'lodash';
import { sentenceCase } from 'change-case';
import { useState, useEffect } from 'react';
// material
import { useTheme } from '@material-ui/core/styles';
import {
  Card,
  Table,
  Stack,
  Avatar,
  Button,
  Checkbox,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  TextField,
  DialogActions,
  CircularProgress
} from '@material-ui/core';
// redux
import { useDispatch, useSelector } from 'src/redux/store.js';
import { getUserList, deleteUser } from 'src/redux/slices/user.js';
// import { UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';

// routes
// components
import Page from 'src/components/Page.js';
import Label from 'src/components/Label.js'; 
import Scrollbar from 'src/components/Scrollbar.js';
import SearchNotFound from 'src/components/SearchNotFound.js';
import { UserListHead, UserListToolbar, UserMoreMenu } from 'src/components/_dashboard/user/list/index.js';
import  ProjectListViewToolbar  from 'src/components/_dashboard/user/list/ProjectListViewToolbar';
import  ProjectListMenu  from 'src/components/_dashboard/user/list/ProjectListMenu';
import { useSnackbar } from 'notistack';
import axios from 'axios';
import { useNavigate } from 'react-router';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { REST_API_END_POINT } from 'src/constants/Defaultvalues';
import LoadingScreen from 'src/components/LoadingScreen';
import ConfirmationPopup from '../official-request/ConfirmationPopup';
import FullScreenDialogsAllJobs from 'src/pages/components-overview/material-ui/dialog/FullScreenDialogsAllJobs';
import QbLogo from 'src/assets/quickbookLogo-removebg-preview.png'

// ----------------------------------------------------------------------

  const option = [
    { id: 0, value: 'Inactive' },
    { id: 1, value: 'New' },
    { id: 2, value: 'Open' },
    { id: 3, value: 'Completed' },
    { id: 4, value: 'Hold' },
    { id: 5, value: 'Accepted' },
    { id: 6, value: 'Rejected' },
    { id: 7, value: 'Verified' },
    { id: 6, value: 'Reopen' },
  ]
  const colors = [
    'error',
    'primary',
    'secondary',
    'success',
    'warning',
    'success',
    'error',
    'success',
    'error',
  ]
  
  
// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(array, (_user) => _user.name.toLowerCase().indexOf(query.toLowerCase()) !== -1);
  }
  return stabilizedThis.map((el) => el[0]);
}

const onboard_data=[
    {
        id:0,
        status:'Pending',
        name:'Laffety',
        number:'123456789',
        address:'California',
        total:'23925.00 USD',
        createdon:'12/31/1969',
    },
    {
        id:1,
        status:'Pending',
        name:'K Hovnanian',
        number:'6532611678',
        address:'Manteca',
        total:'11990.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:2,
        status:'Pending',
        name:'Chase Brendle',
        number:'1215165265',
        address:'San Francisco',
        total:'24480.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:3,
        status:'Pending',
        name:'Jane Doe',
        number:'281728173',
        address:'Sedona',
        total:'68206.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:4,
        status:'Pending',
        name:'Adam Sandler',
        number:'3152614141',
        address:'Miami',
        total:'14280.00 USD',
        createdon:'12/31/1969',

    },
    {
        id:5,
        status:'Pending',
        name:'Umila Garib',
        number:'2728738268',
        address:'West Palm Beach',
        total:'11990.00 USD',
        createdon:'12/31/1969',

    },
]

export default function ProjectList( {user,designOrderJob,communityJob, currentTab, setRenderCards, renderCards, projectData, isLoading, setIsEdit, handleFetchEditData,projectId, setProjectId,openViewPage, setOpenViewPage,projectName,setProjectName,removePopupData}) {
  console.log('designOrderJob===========', designOrderJob)
  const theme = useTheme();
  const dispatch = useDispatch();
  const ProjectList = onboard_data; // Replaced ProjectList with onboard_data
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { enqueueSnackbar } = useSnackbar();
  const navigate=useNavigate()
  let userData = JSON.parse(localStorage.getItem('user'))
  const explodedPermissions =userData?.exploded_permissions
  const [isDelete,setIsDelete] = useState(false)
  const [deleteId,setDeleteId] = useState(null)
  const [openHoldPopup, setOpenHoldPopup] = useState(false);
const [openHoldPopupNew, setOpenHoldPopupNew] = useState(false);
  const [openMoveToInprogress, setOpenMoveToInprogress] = useState(false);
   const [holdStatus, setHoldStatus] = useState(null);
   const [holdReason, setHoldReason] = useState('');
    const [isSubmittingHold, setIsSubmittingHold] = useState(false);    
    const [holdReasonError, setHoldReasonError] = useState('');
  const TABLE_HEAD = [
    { id: 'image', label: 'Job Image', alignLeft: false },
    { id: 'id', label: 'QB ID', alignLeft: false },
    { id: 'name', label: 'Job Name', alignRight: false },
    { id: 'customer_name', label: 'Client', alignRight: false },
    { id: 'community_name', label: 'Project', alignRight: false },
    { id: 'createdby', label: 'Created By', alignRight: false },
    { id: 'members', label: 'Members', alignRight: false },
    // { id: 'city', label: 'City Name', alignRight: false },
    { id: 'status', label: 'Status', alignRight: false },
    ...(userData.user_type === 3
      ? []
      : [{ id: 'options', label: 'Options', alignRight: false }])      

  ];
  const TABLE_HEAD2 = [
    { id: 'image', label: 'Job Image', alignLeft: false },
    { id: 'id', label: 'QB ID', alignLeft: false },
    { id: 'name', label: 'Job Name', alignRight: false },
    { id: 'customer_name', label: 'Client', alignRight: false },
    { id: 'community_name', label: 'Project', alignRight: false },
    // { id: 'createdby', label: 'Created By', alignRight: false },
    // { id: 'members', label: 'Members', alignRight: false },
    // { id: 'city', label: 'City Name', alignRight: false },
    // { id: 'status', label: 'Status', alignRight: false },
    ...(userData.user_type === 3
      ? []
      : [{ id: 'options', label: 'Options', alignRight: false }])      

  ];

  useEffect(() => {
    dispatch(getUserList());
  }, [dispatch]);

  // Rest of the code remains unchanged from here
  // ...
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = ProjectList.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleDeleteTask = (status,id)=>{
    try {
      let newStatus = 0
      if ( status === 0 ){
        newStatus = 1
      }else if ( status === 2 ){
        newStatus = 2
      }else{
        newStatus = 0
      }
        
      // const  user  = JSON.parse(window.localStorage.getItem('user'))
      axios.post(`${REST_API_END_POINT}project/delete-project`,{ id: Number(id), status: newStatus },{
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if(response.data.status === 4 || response.data.status === 2 || response.data.status === 1){
          enqueueSnackbar(response.data.message, { variant: 'success' });
          setRenderCards(!renderCards)
          // navigate(PATH_DASHBOARD.project.viewproject+projectId)
        }else if(response.data.status === 5 || response.data.status === 3 || response.data.status === 0){
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        setIsDelete(false)
        setDeleteId(null)
      }).catch((error) => {
        console.error(error);
      })
      }
      catch (error) {
        console.error("Error fetching data:", error);
      }
  }

  const handleUpdateHoldStatus = async (id) => {
    try {
      setOpenHoldPopup(false)
      const user = JSON.parse(window.localStorage.getItem('user'))
      const res = await axios.post(`${REST_API_END_POINT}project/update-job-hold-status`,
        { projectId: Number(id), userId: user.user_id }, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response.data.status === 1) {
          enqueueSnackbar(response.data.message, { variant: 'success' });
          setRenderCards(!renderCards)
        } else if (response.data.status === 0) {
          enqueueSnackbar(response.data.message, { variant: 'error' });
        }
        setDeleteId(null)
      });
    } catch (error) {
      console.error('Error Moving to Hold:', error);
      throw error;
    }
  };
  const handleUpdateHoldStatusDesignJobs = async (reason) => {
    try {
      const user = JSON.parse(window.localStorage.getItem('user'));
      const res = await axios.post(
        `${REST_API_END_POINT}project/update-design-order-job-hold-status`,
        { projectId: Number(deleteId), userId: user.user_id, reason: reason || '' },
        { headers: { 'Content-Type': 'application/json' } }
      );
      if (res.data.status === 1) {
        enqueueSnackbar(res.data.message, { variant: 'success' });
        setRenderCards(true);
        setDeleteId(null)
      } else {
        enqueueSnackbar(res.data.message, { variant: 'error' });
        setDeleteId(null)
      }
    } catch (error) {
      console.error('Error Moving to Hold:', error);
      setDeleteId(null)
    }
  };

    const handleUpdateStatus = async () => {
      try {
        setOpenMoveToInprogress(false)
        const user = JSON.parse(window.localStorage.getItem('user'))
  
        let status = {id: 2}
                  
  
        const res = await axios.post(`${REST_API_END_POINT}design-order/update-design-order-job-status`,
          {status, selectedIds: Number(deleteId), userId: user.user_id, projectId: Number(deleteId)}, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((response) => {
          if (response.data.status === 1) {
            enqueueSnackbar(response.data.message, { variant: 'success' });
            setDeleteId(null)
            setRenderCards(true)
          } else if (response.data.status === 0) {
            enqueueSnackbar(response.data.message, { variant: 'error' });
            setDeleteId(null)
          }
        });
      } catch (error) {
        setDeleteId(null)
        console.error('Error Moving to Hold:', error);
        throw error;
      }
    };
  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleFilterByName = (event) => {
    setFilterName(event.target.value);
  };

  const handleDeleteUser = (userId) => {
    dispatch(deleteUser(userId));
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - projectData.length) : 0;

  const filteredUsers = applySortFilter(projectData, getComparator(order, orderBy), filterName);

  const isUserNotFound = filteredUsers.length === 0;
  const handleClickOpenViewPage=(id,name)=>{
    setProjectId(id)
    setProjectName(name)
    setOpenViewPage(true)
    localStorage.setItem("openProductionPopup", "true");
    localStorage.setItem("projectId", id);
    localStorage.setItem("projectName", name);
    
    // setSearchParams({
    //   open: "true",
    //   // view: "viewPage",
    //   // projectId: id,
    //   // projectName: name,
    // });
  }
  return (
    <>
      <Grid container spacing={3}>
        {isLoading ? <LoadingScreen /> :
          <Grid item xs={12}>
            <Card>
              {/* <ProjectListViewToolbar numSelected={selected.length} filterName={filterName} onFilterName={handleFilterByName} /> */}
  
              <Scrollbar>
                <TableContainer 
                  sx={{ 
                    minWidth: 800, 
                    whiteSpace: "nowrap", 
                    overflowX: "auto",
                    maxHeight: "500px",  // Set a max height to allow scrolling
                    overflowY: "auto",  // Enable vertical scrollbar
                    '&::-webkit-scrollbar': {
                      width: '0.6em',
                      height: '0.6em',
                    },
                    '&::-webkit-scrollbar-track': {
                      background: '#1e1e1e', // dark background to blend with dark UI
                      borderRadius: '4px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                      backgroundColor: '#555', // medium-gray thumb
                      borderRadius: '6px',
                      border: '2px solid #1e1e1e', // contrast border to separate from track
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                      backgroundColor: '#888', // lighter on hover for feedback
                    },
                    '&::-webkit-scrollbar-corner': {
                      backgroundColor: '#1e1e1e' // match your dark background
                    },
                  }}
                >
                  <Table 
                    stickyHeader
                    sx={{
                      '& .MuiTableCell-head': {
                        padding: '8px 12px',
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        height: '48px',
                        minHeight: '48px',
                        maxHeight: '48px',
                        lineHeight: 1.4,
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                        verticalAlign: 'middle'
                      },
                      '& .MuiTableSortLabel-root': {
                        fontSize: '0.75rem',
                        fontWeight: 600,
                        justifyContent: 'flex-start',
                        '& .MuiTableSortLabel-icon': {
                          marginLeft: '4px'
                        }
                      }
                    }}
                  >
                    <UserListHead
                      order={order}
                      orderBy={orderBy}
                      headLabel={designOrderJob ?TABLE_HEAD2 : TABLE_HEAD}
                      rowCount={projectData.length}
                      numSelected={selected.length}
                      onRequestSort={handleRequestSort}
                      onSelectAllClick={handleSelectAllClick}
                    />
                    <TableBody>
                      {projectData?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
                        const status = Number(row.status)
                        const hold = Number(row.hold)
                        const filteredAttachments = row.attachment?.filter(imageItem=>(imageItem?.file_type?.startsWith("image") || imageItem?.file_type === "img")) || []
                         let Newimage = filteredAttachments?.[0]?.name
                                                              ? filteredAttachments[0].name
                                                              : row.customer_pic && row.customer_pic !== 'avatar.jpg'
                                                              ? row.customer_pic
                                                              : 'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'
                        return (
                          <TableRow
                            hover
                            key={0}
                            sx={{
                              '& .MuiTableCell-root': {
                                padding: '8px 12px',
                                fontSize: '0.75rem',
                                height: 'auto',
                                lineHeight: 1.4
                              }
                            }}
                          >
                            <TableCell padding="checkbox">
                              {/* <Checkbox checked={isItemSelected} onChange={(event) => handleClick(event, name)} /> */}
                            </TableCell>
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <img
                                src={Newimage || 'https://t3.ftcdn.net/jpg/04/60/44/08/360_F_460440876_a8lkfz8UHz64eDPFzmSJJZ55UQBNiC0a.jpg'}
                                style={{
                                  width: '40px',
                                  height: '40px',
                                  borderRadius: '5px',
                                  margin: '0 auto',
                                  display: 'block',
                                  objectFit: 'fill',
                                }}
                              />
                            </TableCell>
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <Stack direction="row" alignItems="center" spacing={1}>
                                <Avatar src={QbLogo} alt="QB" sx={{ width: 24, height: 24, objectFit: "cover"}}/>
                                <Typography sx={{ fontSize: '0.75rem' }}>
                                  {designOrderJob? row.id : row?.doc_number || 'N/A'}
                                </Typography>
                              </Stack>
                            </TableCell>
                            {/* <TableCell align="center">{designOrderJob?row.id:row.request_id}</TableCell> */}
                            <TableCell align="left" sx={{
                              fontSize: '0.75rem',
                              cursor: 'pointer',
                              '&:hover': {
                                cursor: 'pointer',
                                textDecoration: 'underline',
                              },

                            }} onClick={() => {
                              if (communityJob) {
                                navigate(PATH_DASHBOARD.project.viewproject + row.id, { state: { fromCommunityJob: true } });
                              } else if (designOrderJob) {
                                navigate(PATH_DASHBOARD.design.viewDesignOrderProject + row.id, { state: { currentTab: currentTab } });
                              }
                              else {
                                handleClickOpenViewPage(row.id, row.name);
                              }
                              // navigate(PATH_DASHBOARD.project.viewproject+row.id)}
                              // handleClickOpenViewPage(row.id,row.name)
                            }
                            }
                            >{row.name}
                            </TableCell>
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{row.customer_name}</TableCell>
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{row.community_name}</TableCell>
                            {!designOrderJob &&<>
                              <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{row.authorized_by}</TableCell>
                              <TableCell align="left" sx={{ fontSize: '0.75rem' }}>{row.member_count}</TableCell>
                              <TableCell align="left" sx={{ fontSize: '0.75rem' }}>
                              <Label
                                variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                                color={colors[status]} >
                                {option.find(row => row.id === status)?.value}
                              </Label>
                            </TableCell>
                            </>}
                            {/* <TableCell align="center">{row.city==='DefaultCity' ? '' : row.city}</TableCell> */}
                           
                            
                            {userData.user_type == 3 ? null :
                            <TableCell align="left" sx={{ fontSize: '0.75rem' }}> 
                                {!designOrderJob ?
                                  <>
                                    {currentTab != "Completed" && <UserMoreMenu hold={hold} text={status === 0 ? 'Activate' : null}
                                      {...((currentTab != "Installations" && currentTab != "Completed" && currentTab != "Hold") ? {
                                        onDeactivate: () => {
                                          if (explodedPermissions?.some(permission => ['Activate/Deactivate Jobs'].includes(permission))) {
                                            handleDeleteTask(status, row.id)
                                          } else {
                                            enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                                          }
                                        }
                                      } : {})}
                                      {...((currentTab != "Installations" && currentTab != "Completed") ? {
                                        onHold: () => {
                                          if (explodedPermissions?.some(permission => ['Activate/Deactivate Jobs'].includes(permission))) {
                                            setDeleteId(row.id)
                                            setOpenHoldPopup(true);
                                          } else {
                                            enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                                          }
                                        }
                                      } : {})}
                                      onDelete={() => {
                                        if (explodedPermissions?.some(permission => ['Activate/Deactivate Jobs'].includes(permission))) {
                                          setIsDelete(true);
                                          setDeleteId(row.id);
                                        } else {
                                          enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                                        }
                                      }}
                                      {...(status !== 3 ? {
                                        onEdit: () => {
                                          if (explodedPermissions?.some(permission => ['Edit Jobs'].includes(permission))) {
                                            setIsEdit(true);
                                            handleFetchEditData(row.id);
                                          } else {
                                            enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })
                                          }
                                        }
                                      } : {})} />}
                                  </> :
                                  <>
                                    {(userData?.user_type != 3 && currentTab != "Completed" && currentTab != "Rejected") &&
                                      <UserMoreMenu
                                        hold={hold}
                                        text={status === 0 ? 'Activate' : null}
                                        {...((currentTab != "Installations" && currentTab != "Completed") ? {
                                          onHold: () => {
                                            if (explodedPermissions?.some(permission => ['Hold Design Order Jobs'].includes(permission))) {
                                              setDeleteId(row.id)
                                              setOpenHoldPopupNew(true);
                                              setHoldStatus(hold)
                                            } else {
                                              enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                                            }
                                          }
                                        } : {})}

                                        {...((currentTab == "New") ? {
                                          onMoveToInprogress: () => {
                                            setDeleteId(row.id)
                                            // if(explodedPermissions?.some(permission => ['Hold Design Order Jobs'].includes(permission))){
                                            setOpenMoveToInprogress(true);
                                            // }else{
                                            //   enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                                            // }
                                          }
                                        } : {})}

                                      />
                                    }
                                  </>
                                }
                            </TableCell>}
                            <ConfirmationPopup
                              open={openHoldPopup}
                              handleClick={() => { handleUpdateHoldStatus(deleteId) }}
                              handleClose={() => { setOpenHoldPopup(false); setDeleteId(null) }}
                              message={hold === 1 ? `You want to move this Job from Hold` : `You want to move this Job to Hold`}
                            />
                          </TableRow>
                        );
                      })}
                      {emptyRows > 0 && (
                        <TableRow style={{ height: 53 * emptyRows }}>
                          <TableCell colSpan={6} />
                        </TableRow>
                      )}
                    </TableBody>
                    {isUserNotFound && (
                      <TableBody>
                        <TableRow>
                          <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                            <SearchNotFound searchQuery={filterName} />
                          </TableCell>
                        </TableRow>
                      </TableBody>
                    )}
                  </Table>
                </TableContainer>
              </Scrollbar>
  
              <TablePagination
                rowsPerPageOptions={[10, 25,50,100]}
                component="div"
                count={projectData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </Card>
            <ConfirmationPopup
              open={isDelete}
              handleClick={()=>handleDeleteTask(2, deleteId)}
              handleClose={() => { setIsDelete(false); setDeleteId(null) }}
              message={'You want to delete this Job. This action will also permanently delete the associated Sales Order and any related data.'}
              // message={'You want to delete this Job. The related Offical Request will also get deleted.'}
            />
            <ConfirmationPopup
              open={openMoveToInprogress}
              handleClick={() => { handleUpdateStatus() }}
              handleClose={() => { setOpenMoveToInprogress(false) }}
              message={`You want to move this Job to Inprogress. \nAll tasks and subtasks will also be moved to Inprogress`}
            />
            <Dialog
              open={openHoldPopupNew}
              onClose={() => {
                setOpenHoldPopupNew(false);
                setHoldReason('');
              }}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
              BackdropProps={{ invisible: true }}
            >
              <DialogTitle id="alert-dialog-title">
                {holdStatus === 1 ? 'Remove from Hold?' : 'Move to Hold?'}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                  {holdStatus === 1
                    ? 'You want to move this Job from Hold.'
                    : 'You want to move this Job to Hold.'}
                </DialogContentText>
                {holdStatus === 0 ? (
                  <TextField
                    sx={{ width: 400 }}
                    label="Reason"
                    type="text"
                    multiline
                    minRows={3}
                    maxRows={7}
                    value={holdReason}
                    onChange={(e) => {
                      setHoldReason(e.target.value);
                      if (holdReasonError) setHoldReasonError('');
                    }}
                    error={Boolean(holdReasonError)}
                    helperText={holdReasonError}
                  />
                ) : ''}
              </DialogContent>
              <DialogActions>
                <Button
                  size="small"
                  variant="contained"
                  onClick={async () => {
                    if (holdStatus === 0 && !holdReason.trim()) {
                      setHoldReasonError('Reason is required to put this Job on Hold.');
                      return;
                    }

                    setIsSubmittingHold(true);
                    await handleUpdateHoldStatusDesignJobs(holdReason);
                    setIsSubmittingHold(false);
                    setOpenHoldPopupNew(false);
                    setDeleteId(null)
                    setHoldStatus(null)
                    setHoldReason('');
                    setHoldReasonError('');
                  }}
                  disabled={isSubmittingHold}
                >
                  {isSubmittingHold ? <CircularProgress size={20} color="inherit" /> : 'OK'}
                </Button>
                <Button
                  size="small"
                  variant="outlined"
                  onClick={() => {
                    setOpenHoldPopupNew(false);
                    setHoldReason('');
                    setHoldStatus(null);
                    setDeleteId(null);
                  }}
                  sx={{ color: theme.palette.error.main }}
                >
                  Cancel
                </Button>
              </DialogActions>
            </Dialog>
          </Grid>
        }
      </Grid>
      <FullScreenDialogsAllJobs
      initialFromCalender={"false"}
                  open={openViewPage}
                  setOpen={setOpenViewPage}
                  renderCards={renderCards}
                  handleClickOpen={handleClickOpenViewPage}
                  projectName={projectName}
                  removePopupData={removePopupData}
                  projectId={projectId}
                  setRenderCards={setRenderCards}
                  />
    </>
  );
}
